import React from "react";
import {
    ExpandIcon,
    CollapseIcon,
    CopyEntireGebrekIcon,
    CopyLocationsToNewIcon,
    DeleteIcon,
} from "../../common/icons";

export default function GebrekHeader({
    gebrek,
    title,
    effectiveColor,
    isCollapsed,
    onToggleCollapse,
    onCopyEntireGebrek,
    onCreateNewWithLocations,
    onDelete,
}) {
    return (
        <div
            className={`flex justify-between items-center p-3 cursor-pointer border-b ${isCollapsed ? "" : "bg-gray-50"
                }`}
            onClick={() => onToggleCollapse(gebrek.gebrekid)}
        >
            <div className="flex items-center space-x-2 flex-grow mr-2 min-w-0">
                <button
                    type="button"
                    onClick={(e) => {
                        e.stopPropagation();
                        onToggleCollapse(gebrek.gebrekid);
                    }}
                    className="focus:outline-none flex-shrink-0"
                    aria-expanded={!isCollapsed}
                    aria-controls={`gebrek-details-${gebrek.gebrekid}`}
                >
                    {isCollapsed ? <ExpandIcon /> : <CollapseIcon />}
                </button>
                <p
                    className="text-base font-semibold truncate"
                    style={{ color: effectiveColor }}
                    title={title}
                >
                    {title}
                </p>
            </div>
            <div className="flex items-center space-x-2 flex-shrink-0">
                <button
                    type="button"
                    onClick={(e) => {
                        e.stopPropagation();
                        onCopyEntireGebrek(gebrek);
                    }}
                    className="p-1 rounded hover:bg-green-100 focus:outline-none focus:ring-2 focus:ring-green-300"
                    title="Kopieer Gehele Gebrek"
                >
                    <CopyEntireGebrekIcon />
                </button>
                <button
                    type="button"
                    onClick={(e) => {
                        e.stopPropagation();
                        onCreateNewWithLocations(gebrek);
                    }}
                    className="p-1 rounded hover:bg-blue-100 focus:outline-none focus:ring-2 focus:ring-blue-300"
                    title="Nieuw Gebrek met Locaties van Dit Gebrek"
                >
                    <CopyLocationsToNewIcon />
                </button>
                <button
                    type="button"
                    onClick={(e) => {
                        e.stopPropagation();
                        onDelete(gebrek.gebrekid);
                    }}
                    className="p-1 rounded hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-red-300"
                    title="Verwijder Gebrek"
                >
                    <DeleteIcon />
                </button>
            </div>
        </div>
    );
}
